import React, { useCallback, memo } from 'react';
import useLocale from '@/hooks/useLocale';
import * as Styles from './ProductTemplateAbout.styles';
import { useSelector, shallowEqual } from 'react-redux';
import { IconArrow } from 'gatorcomponents';
import ContentSection from '@/pages/Products/VpsOciDetailPage/commons/ContentSection';

const ProductTemplateAbout = ({
  setShowProductTemplatesPage,
}) => {
  const vps = useSelector(state => state.vpsOci?.data?.vps, shallowEqual);

  const { productDetails: productDetailsLocale } = useLocale();
  const { store: localeStore } = productDetailsLocale.vpsOci;

  const handleBackButtonClick = useCallback(() => {
    setShowProductTemplatesPage(false);
  }, [setShowProductTemplatesPage]);

  if (!vps || Object.keys(vps).length === 0) return null;

  return (
    <ContentSection
      direction="row"
      align="flex-start"
      justify="flex-start"
      testId="vpsoci-templates-about-section"
    >
      <Styles.TitleWrapper>
        <Styles.BackButton onClick={() => handleBackButtonClick()} data-testid="vpsoci-templates-page-back-button">
          <IconArrow
            size="lg"
            color="lowDark"
            testId="vpsoci-templates-page-back-button-icon"
            direction="left"
          />
        </Styles.BackButton>
        <Styles.Content>
          <Styles.Title data-testid="vpsoci-templates-about-title">{localeStore.details.title}</Styles.Title>
          <Styles.Description data-testid="vpsoci-templates-about-description">{localeStore.details.description}</Styles.Description>
        </Styles.Content>
      </Styles.TitleWrapper>
    </ContentSection>
  );
};

export default memo(ProductTemplateAbout);
